import Config from "../../Config";

const PluginVersion = async () => {
    await Config.getConfigEnv();
    return Config.env.WRC_PLUGIN_DOCKER_TAG
}

export default PluginVersion